import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaUser,
  FaLock,
  FaFileAlt,
  FaSignOutAlt,
  FaPhoneAlt,
  FaUsers,
  FaVideo,
  FaUserCheck,
} from "react-icons/fa";
import { BiSolidDashboard } from "react-icons/bi";
import user from "../../../assets/images/Home/user.png";
import { Link } from "react-router-dom";
import Dashboard from "./Dashboard";
import Profile from "./Profile";
import CourseList from "./CourseList";
import AttendanceList from "./AttendanceList";
import PaymentList from "./PaymentList";
// import ChangePassword from "./ChangePassword";
import Refer from "./Refer";
import { useNavigate } from "react-router-dom";
import OrderList from "../Dashboard/OrderList";
import { MdLibraryBooks } from "react-icons/md";
import LiveClass from "./LiveClass";
import axios from "axios";

const UserProfile = ({ totalCourses }) => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");
  const [profile, setProfile] = useState([]);
  const [bgImage, setBgImage] = useState("");
  const navigate = useNavigate();
  const [courseProps, setCourseProps] = useState({});
  const [dashboard, setDashboard] = useState({});
  useEffect(() => {
    profilelist();
    bannerimg();
  }, []);
  const profilelist = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/profile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: user_id }),
      });

      if (!res.ok) throw new Error("Failed to fetch subjects");

      const data = await res.json();
      setProfile(data.data);
    } catch (err) {
      console.error("Error fetching subjects:", err);
    } finally {
      // setSubjectsLoading(false);
    }
  };
  const bannerimg = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
      );

      const baseUrl = res.data.imagePath;
      const courseImage = res.data.home_setting[0]?.course_image;

      // Full image URL
      const fullUrl = baseUrl + courseImage;

      setBgImage(fullUrl);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "dashboard":
        return (
          <>
            <Dashboard setActiveTab={setActiveTab} />
          </>
        );

      case "profile":
        return (
          <>
            <Profile />
          </>
        );

      case "course":
        return (
          <>
            <CourseList {...courseProps} />
          </>
        );

      // case "password":
      //   return (
      //     <>
      //       <ChangePassword />
      //     </>
      //   );

      case "liveClass":
        return (
          <>
            <LiveClass />
          </>
        );
      case "attendance":
        return (
          <>
            <AttendanceList />
          </>
        );

      // case "payment":
      //   return (
      //     <>
      //       <PaymentList />
      //     </>
      //   );
      case "refer":
        return (
          <>
            <Refer />
          </>
        );
      case "order":
        return (
          <>
            <OrderList />
          </>
        );

      default:
        return <h5>Select an option</h5>;
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("username");
    localStorage.removeItem("mobile");
    localStorage.removeItem("email");
    localStorage.removeItem("postLoginRedirect");
    //  localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <section className="course Profile">
        <div className="page_header"></div>
        <div className="rs-breadcrumbs breadcrumbs-overlay">
          <div className="breadcrumbs-img">
            <img src={bgImage} alt="Breadcrumbs bg" />
          </div>
          <div className="breadcrumbs-text white-color">
            <h1 className="page-title">Dashboard</h1>
          </div>
        </div>
        <Container fluid className="py-4">
          <Row>
            {/* Sidebar */}
            <Col lg={3} className="mb-4">
              <div className="border rounded p-3 shadow-sm shadow_light">
                <div className="text-center mb-3">
                  <div className="mb-2">
                    <img
                      src={user}
                      alt="user"
                      width="80px"
                      className="user_image"
                    />
                    <h4>{profile.username}</h4>
                  </div>
                  <div className="d-flex justify-content-center">
                    <Link
                      class="educate-btn sm d-xl-flex d-none d-flex align-items-center"
                      to="#"
                    >
                      <span class="educate-btn__curve"></span>
                      <FaPhoneAlt className="text-warning me-2" />{" "}
                      {profile.mobile}
                    </Link>
                  </div>
                </div>
                <hr />
                <ul className="list-unstyled profle_tabs">
                  <li
                    className={`mb-2 p-2 rounded ${
                      activeTab === "dashboard"
                        ? "bg-primary text-white"
                        : "cursor-pointer"
                    }`}
                    onClick={() => setActiveTab("dashboard")}
                  >
                    <BiSolidDashboard className="me-2" /> Dashboard
                  </li>
                  <li
                    className={`mb-2 p-2 rounded ${
                      activeTab === "profile" ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => setActiveTab("profile")}
                  >
                    <FaUser className="me-2" /> My Profile
                  </li>
                  <li
                    className={`mb-2 p-2 rounded ${
                      activeTab === "refer" ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => setActiveTab("refer")}
                  >
                    <FaUsers className="me-2" />
                    Refer & Earn
                  </li>
                  <li
                    className={`mb-2 p-2 rounded ${
                      activeTab === "order" ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => setActiveTab("order")}
                  >
                    <MdLibraryBooks className="me-2" />
                    Books Order list
                  </li>
                  <li
                    className={`mb-2 p-2 rounded ${
                      activeTab === "liveClass" ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => setActiveTab("liveClass")}
                  >
                    <FaVideo className="me-2" />
                    Live Class
                  </li>
                  <li
                    className={`mb-2 p-2 rounded ${
                      activeTab === "attendance" ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => setActiveTab("attendance")}
                  >
                    <FaUserCheck className="me-2" />
                    Attendance
                  </li>
                  <li
                    className={`mb-2 p-2 rounded ${
                      activeTab === "course" ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => setActiveTab("course")}
                  >
                    <FaFileAlt className="me-2" />
                    My Subscriptions
                  </li>
                  {/* <li
                    className={`mb-2 p-2 rounded ${
                      activeTab === "password" ? "bg-primary text-white" : ""
                    }`}
                    onClick={() => setActiveTab("password")}
                  >
                    <FaLock className="me-2" /> Change Password
                  </li> */}

                  <span className="w-100">
                    <li
                      className="mb-2 text-danger p-2 rounded"
                      style={{ cursor: "pointer" }}
                      onClick={handleLogout}
                    >
                      <FaSignOutAlt className="me-2" /> Logout
                    </li>
                  </span>
                </ul>
              </div>
            </Col>

            {/* Dynamic Content Area */}
            <Col lg={9}>
              <div className="border rounded shadow-sm shadow_light p-md-3">
                {renderContent()}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default UserProfile;
